import React, { createContext, useContext, useState, useEffect } from 'react';  

// Create Auth Context  
const AuthContext = createContext({});  

export const AuthProvider = ({ children }) => {  
    const [auth, setAuth] = useState(() => {  
        // Get stored user from localStorage on initial render  
        const storedUser = localStorage.getItem('user');  
        return storedUser ? { user: JSON.parse(storedUser) } : { user: null };  
    });  

    useEffect(() => {  
        // Store user into localStorage whenever auth state changes  
        if (auth.user) {  
            localStorage.setItem('user', JSON.stringify(auth.user));  
        } else {  
            localStorage.removeItem('user');  
        }  
    }, [auth.user]);  

    return (  
        <AuthContext.Provider value={{ auth, setAuth }}>  
            {children}  
        </AuthContext.Provider>  
    );  
};  

export default AuthContext;